import TeakInfo from './TeakInfo.jsx'
import MahognyInfo from './MahognyInfo.jsx'
import SteamWoodInfo from './SteamWoodInfo.jsx'
import PlywoodInfo from './PlywoodInfo.jsx'
import FanerInfo from './FanerInfo.jsx'
import StainlessInfo from './StainlessInfo.jsx'

const InfoPages = {
  Teak: TeakInfo,
  Mahogny: MahognyInfo,
  SteamWood: SteamWoodInfo,
  Plywood: PlywoodInfo,
  Fanér: FanerInfo,
  Rostfritt: StainlessInfo,
}

export default InfoPages
